/* unplugin-vue-components disabled */import { render } from "./SpocCourse.vue?vue&type=template&id=a950202a&scoped=true"
import script from "./SpocCourse.vue?vue&type=script&lang=js"
export * from "./SpocCourse.vue?vue&type=script&lang=js"

import "./SpocCourse.vue?vue&type=style&index=0&id=a950202a&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户哈工程-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a950202a"]])

export default __exports__